// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 34) return "js/backend/category.js";
	if (chunkId === 314) return "js/backend/productdetails.js";
	if (chunkId === 443) return "js/backend/about.js";
	if (chunkId === 631) return "js/backend/contact.js";
	if (chunkId === 720) return "js/backend/faq.js";
	if (chunkId === 523) return "js/backend/shop.js";
	if (chunkId === 231) return "js/backend/checkout.js";
	if (chunkId === 511) return "js/backend/cart.js";
	if (chunkId === 966) return "js/backend/dashboard.js";
	if (chunkId === 685) return "js/backend/register.js";
	if (chunkId === 535) return "js/backend/login.js";
	if (chunkId === 569) return "js/backend/wishlist.js";
	if (chunkId === 888) return "js/backend/compare.js";
	if (chunkId === 845) return "js/backend/profile.js";
	if (chunkId === 954) return "js/backend/others.js";
	if (chunkId === 435) return "js/backend/ordersuccess.js";
	if (chunkId === 299) return "js/backend/blogdetails.js";
	if (chunkId === 819) return "js/backend/ordertrack.js";
	if (chunkId === 353) return "js/backend/353.js";
	if (chunkId === 43) return "js/backend/43.js";
	if (chunkId === 931) return "js/backend/931.js";
	if (chunkId === 82) return "js/backend/82.js";
	if (chunkId === 988) return "js/backend/988.js";
	if (chunkId === 501) return "js/backend/501.js";
	if (chunkId === 750) return "js/backend/750.js";
	if (chunkId === 669) return "js/backend/669.js";
	if (chunkId === 267) return "js/backend/267.js";
	if (chunkId === 218) return "js/backend/218.js";
	if (chunkId === 178) return "js/backend/178.js";
	if (chunkId === 319) return "js/backend/319.js";
	if (chunkId === 923) return "js/backend/923.js";
	if (chunkId === 782) return "js/backend/782.js";
	if (chunkId === 112) return "js/backend/112.js";
	if (chunkId === 889) return "js/backend/889.js";
	// return url for filenames based on template
	return undefined;
};